// packages
import cx from 'classnames';
import { Component, h } from 'preact';
import * as d3 from 'd3';

// components
import DistrictStatsNew from './DistrictStatsNew';
import DistrictMapNew from './DistrictMapNew';

// internal
import Statsdata from './../../../data/2024_stats.json';

import { get_directory_slug } from '../election-utils';


type Props = {
  contest: { [key: string]: any };
  columnCount: number;
  notes: { [key: string]: any };
  tableHeader: JSX.Element;
  contestTitle: string;
  contestOffice: string;
  renderCandidate: any;
  visibleCandidatesCount?: number;
};

class EmptyTable extends Component<Props> {
  constructor() {
    super();
    this.getContainerWidth = this.getContainerWidth.bind(this);

    this.state = {
      width: null,
      height: 450,
      bodyWidth: null,
      widthMobile: null,
      geometry: null,
      isLoaded: false,
      stats: null,
      simplified_geo: null,
      breakPoint: 544,
    };
  }

  getStats(district, chamber) {
    const stats = Statsdata.stats.filter(s => s.district == district).find(s => s.office == chamber);
    return(stats)
  }

  componentDidMount() {
    this.fetchDistrict();
    let { width, bodyWidth, widthMobile } = this.getContainerWidth();

    this.setState({
      width: width,
      bodyWidth: bodyWidth,
      widthMobile: widthMobile,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.contest !== prevProps.contest) {
      this.fetchDistrict();
    }
  }

  fetchDistrict() {
    const { contestNum, slug } = this.props;
    

    // We first get the geometry (borders), stats and simplified geometries (borders for static images) for the previous 2020 districts

    const stats = this.getStats(contestNum, slug);

    this.setState({ isLoaded: true, stats });

  }



  getContainerWidth() {
    const base = d3.select('.seat__race');

    const baseMobile = d3.select('.seat__race');

    const body = d3.select('body');

    // const width = base.node().offsetWidth;
    const widthMobile = baseMobile.node().offsetWidth;
    const bodyWidth = window.innerWidth;

    const width = bodyWidth > 543 ? 220 : bodyWidth > 330 ? 280 : bodyWidth - 70;
    this.setState({
      width: width,
      bodyWidth: bodyWidth
    })

    return { width, bodyWidth, widthMobile };
  }
  render() {
    const {
      contestTitle,
      contestNum,
      tableHeader,
      slug,
      point,
    } = this.props;

    const { isLoaded, stats, width, bodyWidth, widthMobile } = this.state;



    let colorClass, seatClass;

    if (stats) {
      colorClass = cx('font-weight-bold', {
        'biden': stats['Winner'] == 'Biden',
        'trump': stats['Winner'] == 'Trump',
      })
      seatClass = cx('seat', {
        'add_bottom_margin': slug == 'texas-house' || slug == 'state-board-of-education',
      })
    }

    let directory_slug;

    if (contestNum) {
      directory_slug = get_directory_slug(contestTitle);
    }


    return (
      <div class={seatClass}>
        <h3 class="seat__title balance-text"><span>{contestTitle} {contestNum}
        </span>
                {directory_slug[0] != null && (
              <a class="t-links-unset"
                href={`https://www.texastribune.org/directory/districts/${directory_slug[0]['directory-slug']}/${contestNum}`}
              >
                <span class="icon-div" title="Click to learn more about this district">
                  <svg class="icon icon-info">
                    <use xlinkHref="#icon-info"></use>
                  </svg>
                </span>
              </a>
            )}
        </h3>
        <div class="seat__race no_election__wrapper">
        <table class="race__candidates"> {tableHeader} </table>
        <div class="no_election">Seat is not up for election this year.</div>
        </div>
       
        {isLoaded == true && (
          <div class="district-grid__wrapper">
          <h4 class="seat__section-header">About this district</h4>
          <div class="district-grid">
                <DistrictStatsNew
                  name={contestTitle}
                  districtRace={contestTitle}
                  district={contestNum}
                  slug={slug}
                  stats={stats}
                  width={width}
                  bodyWidth={bodyWidth}
                />
                <DistrictMapNew
                  districtRace={contestTitle}
                  district={contestNum}
                  point={point}
                  slug={slug}
                  width={width}
                />
          </div>
            
          </div>
        )}
      </div>
    );
  }
}

EmptyTable.defaultProps = {
  isShowcaseRace: false,
  includeCountyRundown: false,
  visibleCandidatesCount: 3,
};

export default EmptyTable;